import useSWR from "swr"
import { fetchApiGateway } from "@nova/fetch-api-gateway"

export const useSpidertracksIntegration = (orgId: string | undefined) => {
    const { data, isLoading, mutate } = useSWR(
        orgId ? ["spidertracks-integration", orgId] : null,
        () =>
            fetchApiGateway("get /org/:orgId/spidertracks/authorize", {
                params: { orgId: orgId! },
            }),
        { revalidateOnFocus: false }
    )

    return {
        email: data?.email,
        isLoading,
        invalidate: mutate,
    }
}
